import React from 'react';
import { NavLink } from 'react-router-dom';
import useTranslate from '../../customHooks/useTranslate';

export default function GenericMenu({ menuData }) {
    const translate = useTranslate();

    return (
        <nav className='navbar__header'>
            <ul className='navbar__header--list'>
                {menuData.map(itemNav => {
                    const { linkTo, name } = itemNav;
                    return (
                        <li key={name} className='navbar__header--item'>
                            <NavLink
                                to={linkTo}
                                className='navbar__header--item-link'
                            >
                                {translate(name)}
                            </NavLink>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
